import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, isDeactivated } = useAuth();

  if (isAuthenticated) {
    const {
      root,
      uncategorizedCreatePage,
    } = PATH_DASHBOARD;
    
    const path = window.ppc ? uncategorizedCreatePage : root;
    
    return <Navigate to={path} />;
  }
  if(isDeactivated){
    return <Navigate to={PATH_AUTH.inactive} />;
  }

  return <>{children}</>;
}
